import httpClient from "../http/http-client";
import { IScreenLabel } from './screen-labels.model';

export default class ScreenLabelsService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getAll(queryString?: string): Promise<IScreenLabel[]> {
    return this.http.get(`screen-label${queryString ? queryString : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async createOrUpdate(screenLabels: { [key: string]: string | null }): Promise<IScreenLabel[]> {
    return this.http.post(`screen-label`, screenLabels)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }
}
